const defaultSwrvConfig = {
    revalidateOnFocus: false,
};

export default defaultSwrvConfig;
